import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import StickyPlant from "../match/ChooseProf/StickyPlant";

const MaintenancePage = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.white.main,
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        margin: "auto",
        maxWidth: "1440px",
        padding: "1.5rem 2.5rem",
      })}
    >
      <Box
        alt="logo BloomUp"
        component="img"
        src="https://bloomup-production-www.s3.eu-central-1.amazonaws.com/Logo_d2b040aaa2.svg"
        sx={(theme) => ({
          marginBottom: "2rem",
          marginRight: "auto",
          maxHeight: "2.25rem",
          [theme.breakpoints.down("sm")]: {
            marginBottom: "0.5rem",
          },
        })}
      />
      <Box
        sx={(theme) => ({
          alignItems: "center",
          display: "flex",
          flex: 1,
          justifyContent: "center",
          [theme.breakpoints.down(780)]: {
            alignItems: "flex-start",
            justifyContent: "flex-start",
            paddingTop: "2rem",
          },
        })}
      >
        <Box
          sx={(theme) => ({
            alignItems: "center",
            background: theme.palette.white.dark,
            borderRadius: "60% 40% 65% 70% / 65% 65% 75% 75%",
            display: "flex",
            flexDirection: "row",
            gap: "3rem",
            justifyContent: "space-between",
            maxWidth: "90%",
            padding: "4rem 6rem",
            position: "relative",
            transform: "rotate(-1.5deg)",
            width: "100%",
            [theme.breakpoints.down("sm")]: { gap: "1rem", padding: "0.5rem" },
            [theme.breakpoints.down(780)]: {
              background: "transparent",
              borderRadius: 0,
              flexDirection: "column",
              gap: "2rem",
              maxWidth: "100%",
              transform: "none",
            },
          })}
        >
          <Box
            sx={(theme) => ({
              flex: 1,
              transform: "rotate(+1.5deg)",
              [theme.breakpoints.down("sm")]: {
                textAlign: "center",
                transform: "none",
              },
            })}
          >
            <Typography
              sx={(theme) => ({
                marginBottom: "1.5rem",
                [theme.breakpoints.down(768)]: {
                  fontSize: "2.5rem",
                },
                [theme.breakpoints.down(440)]: {
                  fontSize: "2rem",
                },
              })}
              variant="h1"
            >
              {t("common:maintenance.page.title")}
            </Typography>
            <Typography
              sx={(theme) => ({
                whiteSpace: "pre-line",
                [theme.breakpoints.down(768)]: {
                  fontSize: "1.25rem",
                },
                [theme.breakpoints.down(440)]: {
                  fontSize: "1.1rem",
                },
              })}
              variant="h4"
            >
              {t("common:maintenance.page.description")}
            </Typography>
          </Box>
          <Box
            component={StickyPlant}
            sx={(theme) => ({
              flexShrink: 0,
              maxWidth: "40%",
              transform: "rotate(+1.5deg)",
              width: "35%",
              [theme.breakpoints.down("sm")]: {
                maxWidth: "60%",
                transform: "none",
                width: "auto",
              },
            })}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default MaintenancePage;
